import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import SubMenuItem from "../SubMenuItem";
import LatestPostCard from "../LatestPostCard";

const LearnMenu = ({ isActive, latestPosts }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    query {
      ...LearnMenuIcons
    }
  `);

  return (
    <div
      id="sub-menu__learn"
      className={cx(
        "pl-xl-4 container sub-menu sub-menu__learn row",
        { active: isActive },
        { inactive: !isActive }
      )}
    >
      <div className="col-4 col-xl-3 mt-4 py-2">
        <div className="row m-0 w-100">
          <SubMenuItem
            title={t("menu.learn.learn.title")}
            description={t("menu.learn.learn.description")}
            imageSrc={data.learnIcon.publicURL}
            linkTo={`/learn/`}
          />
        </div>
        <div className="row m-0 w-100">
          <SubMenuItem
            title={t("menu.learn.coinInfo.title")}
            description={t("menu.learn.coinInfo.description")}
            imageSrc={data.coinInfoIcon.publicURL}
            linkTo={`/coin-info/`}
          />
        </div>
      </div>
      <div className="col-4 col-xl-3 mt-4 py-2">
        <div className="row m-0 w-100">
          <SubMenuItem
            title={t("menu.learn.glossary.title")}
            description={t("menu.learn.glossary.description")}
            imageSrc={data.glossaryIcon.publicURL}
            linkTo={`/glossary/`}
          />
        </div>
      </div>

      {latestPosts && (
        <div className="col-4 col-xl-6 mt-4 pt-2">
          <div className="row justify-content-center">
            <LatestPostCard post={latestPosts[0]} />
            <LatestPostCard className="d-xl-block" post={latestPosts[1]} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LearnMenu;
